/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
// import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';

const pathname = '/revenue-statistics';

export const RevenueStatisticApi = {
  findRevenueExpenseProfitEntity: async (
    option: FindRevenueExpenseProfitEntityQuery
  ) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindRevenueExpenseProfitEntityQuery {
  entityID: string;
  startedAt: string;
  finishedAt: string;
  withDay?: boolean;
  withWeek?: boolean;
  withMonth?: boolean;
  withYear?: boolean;
  type?: 'REVENUE' | 'EXPENSE' | 'ALL';
  isAutoSplitTime?: boolean;
}
